import React from "react";
import { Box, Typography, makeStyles, Button } from "@material-ui/core";
import { Link } from "react-router-dom";
const useStyles = makeStyles((theme) => ({
  card: {
    position: "relative",
    minHeight: "200px",
    "& h3": {
      fontSize: "30px",
      fontWeight: "400",
      color: "#000",
      [theme.breakpoints.down("xs")]: {
        fontSize: "20px",
      },
      [theme.breakpoints.down("sm")]: {
        fontSize: "18px",
      },
    },
    "& p": {
      fontSize: "20px",
      fontWeight: "400",
      color: "#000",
    },
  },
}));

function HelpCenterCard(props) {
  const classes = useStyles();
  const { data, qty, percentage } = props;
  return (
    <>
      <Box
        className={classes.card}
        style={{
          padding: "12px",
          backgroundColor: data?.color,
        }}
      >
        <Typography
          variant='h3'
          style={{ position: "absolute", top: "25px", right: "25px" }}
        >
          {Number(percentage).toFixed(0)}%
        </Typography>
        <Box display='flex' jutifyContent='center' alignItems='center'>
          <img
            src={data?.img}
            width='100%'
            alt='Card Image'
            style={{ maxWidth: "180px", margin: "0 auto" }}
          />
        </Box>
        <Box mt={2} textAlign='center'>
          <Typography variant='h3' style={{ padding: "10px 0px" }}>
            {data.text2}
          </Typography>
          <Typography
            variant='body2'
            style={{ color: "#000", fontWeight: "600" }}
          >
            QTY &nbsp;:&nbsp;&nbsp;
            {qty}
          </Typography>
        </Box>
      </Box>
    </>
  );
}

export default HelpCenterCard;
